"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PULL_REQUEST_REVIEWER_EVENTS = exports.EventType = exports.OriginatingEntityType = exports.EventParticipantType = exports.IssueEventType = exports.CommitEventType = exports.PullRequestEventType = void 0;
var PullRequestEventType;
(function (PullRequestEventType) {
    PullRequestEventType["PullRequestFirstCommit"] = "PULL_REQUEST_FIRST_COMMIT";
    PullRequestEventType["PullRequestOpened"] = "PULL_REQUEST_OPENED";
    PullRequestEventType["PullRequestMerged"] = "PULL_REQUEST_MERGED";
    PullRequestEventType["PullRequestClosed"] = "PULL_REQUEST_CLOSED";
    PullRequestEventType["PullRequestAssigned"] = "PULL_REQUEST_ASSIGNED";
    PullRequestEventType["PullRequestAssignedByUser"] = "PULL_REQUEST_ASSIGNED_BY_USER";
    PullRequestEventType["PullRequestUnassigned"] = "PULL_REQUEST_UNASSIGNED";
    PullRequestEventType["PullRequestUnassignedByUser"] = "PULL_REQUEST_UNASSIGNED_BY_USER";
    PullRequestEventType["PullRequestComment"] = "PULL_REQUEST_COMMENT";
    PullRequestEventType["PullRequestMention"] = "PULL_REQUEST_MENTION";
    PullRequestEventType["PullRequestReviewRequested"] = "PULL_REQUEST_REVIEW_REQUESTED";
    PullRequestEventType["PullRequestReviewRequestedByUser"] = "PULL_REQUEST_REVIEW_REQUESTED_BY_USER";
    PullRequestEventType["PullRequestReviewRequestRemoved"] = "PULL_REQUEST_REVIEW_REQUEST_REMOVED";
    PullRequestEventType["PullRequestReviewRequestRemovedByUser"] = "PULL_REQUEST_REVIEW_REQUEST_REMOVED_BY_USER";
    PullRequestEventType["PullRequestReviewedCommented"] = "PULL_REQUEST_REVIEWED_COMMENTED";
    PullRequestEventType["PullRequestReviewedChangesRequested"] = "PULL_REQUEST_REVIEWED_CHANGES_REQUESTED";
    PullRequestEventType["PullRequestReviewedApproved"] = "PULL_REQUEST_REVIEWED_APPROVED";
    PullRequestEventType["PullRequestMentionedByUser"] = "PULL_REQUESTED_MENTIONED_BY_USER";
    PullRequestEventType["PullRequestSubscribed"] = "PULL_REQUEST_SUBSCRIBED";
    PullRequestEventType["PullRequestUnlabeled"] = "PULL_REQUEST_UNLABELED";
    PullRequestEventType["PullRequestLabeled"] = "PULL_REQUEST_LABELED";
    PullRequestEventType["PullRequestUnsubscribed"] = "PULL_REQUEST_UNSUBSCRIBED";
    PullRequestEventType["PullRequestReferenced"] = "PULL_REQUEST_REFERENCED";
    PullRequestEventType["PullRequestReopened"] = "PULL_REQUEST_REOPENED";
    PullRequestEventType["PullRequestRenamed"] = "PULL_REQUEST_RENAMED";
    PullRequestEventType["PullRequestDeployed"] = "PULL_REQUEST_DEPLOYED";
    PullRequestEventType["PullRequestReadyForReview"] = "PULL_REQUEST_READY_FOR_REVIEW";
    PullRequestEventType["PullRequestReviewDismissed"] = "PULL_REQUEST_REVIEW_DISMISSED";
    PullRequestEventType["PullRequestCommentDeleted"] = "PULL_REQUEST_COMMENT_DELETED";
    PullRequestEventType["PullRequestCommitCommented"] = "PULL_REQUEST_COMMIT_COMMENTED";
    PullRequestEventType["PullRequestLineCommented"] = "PULL_REQUEST_LINE_COMMENTED";
    PullRequestEventType["PullRequestCrossReferenced"] = "PULL_REQUEST_CROSS_REFERENCED";
    PullRequestEventType["PullRequestUnknown"] = "PULL_REQUEST_UNKNOWN";
})(PullRequestEventType = exports.PullRequestEventType || (exports.PullRequestEventType = {}));
var CommitEventType;
(function (CommitEventType) {
    CommitEventType["CommitCommitted"] = "COMMIT_COMMITTED";
    CommitEventType["CommitAuthored"] = "COMMIT_AUTHORED";
})(CommitEventType = exports.CommitEventType || (exports.CommitEventType = {}));
var IssueEventType;
(function (IssueEventType) {
    IssueEventType["IssueOpened"] = "ISSUE_OPENED";
    IssueEventType["IssueAssigned"] = "ISSUE_ASSIGNED";
    IssueEventType["IssueAssignedByUser"] = "ISSUE_ASSIGNED_BY_USER";
    IssueEventType["IssueStatusChanged"] = "ISSUE_STATUS_CHANGED";
    IssueEventType["IssueAttachment"] = "ISSUE_ATTACHMENT";
    IssueEventType["IssueCommentDeleted"] = "ISSUE_COMMENT_DELETED";
    IssueEventType["IssueComponentChanged"] = "ISSUE_COMPONENT_CHANGED";
    IssueEventType["IssueDescriptionChanged"] = "ISSUE_DESCRIPTION_CHANGED";
    IssueEventType["IssueDueDateChanged"] = "ISSUE_DUE_DATE_CHANGED";
    IssueEventType["IssueEnvironmentChanged"] = "ISSUE_ENVIRONMENT_CHANGED";
    IssueEventType["IssueFixVersionChanged"] = "ISSUE_FIX_VERSION_CHANGED";
    IssueEventType["IssueTypeChanged"] = "ISSUE_TYPE_CHANGED";
    IssueEventType["IssueLabelsChanged"] = "ISSUE_LABELS_CHANGED";
    IssueEventType["IssuePriorityChanged"] = "ISSUE_PRIORITY_CHANGED";
    IssueEventType["IssueProjectChanged"] = "ISSUE_PROJECT_CHANGED";
    IssueEventType["IssueReporterChanged"] = "ISSUE_REPORTER_CHANGED";
    IssueEventType["IssueResolutionChanged"] = "ISSUE_RESOLUTION_CHANGED";
    IssueEventType["IssueResolutionDateChanged"] = "ISSUE_RESOLUTION_DATE_CHANGED";
    IssueEventType["IssueSummaryChanged"] = "ISSUE_SUMMARY_CHANGED";
    IssueEventType["IssueOriginalTimeEstimateChanged"] = "ISSUE_ORIGINAL_TIME_ESTIMATE_CHANGED";
    IssueEventType["IssueTimeEstimateChanged"] = "ISSUE_TIME_ESTIMATE_CHANGED";
    IssueEventType["IssueTimeSpentChanged"] = "ISSUE_TIME_SPENT_CHANGED";
    IssueEventType["IssueVersionsChanged"] = "ISSUE_VERSIONS_CHANGED";
    IssueEventType["IssueSprintChanged"] = "ISSUE_SPRINT_CHANGED";
    IssueEventType["IssueStoryPointsChanged"] = "ISSUE_STORY_POINTS_CHANGED";
    IssueEventType["IssueTShirtSizeChanged"] = "ISSUE_TSHIRT_SIZE_CHANGED";
    IssueEventType["IssueUnknownFieldChange"] = "ISSUE_UNKNOWN_FIELD_CHANGED";
    IssueEventType["IssueCustomFieldChange"] = "ISSUE_CUSTOM_FIELD_CHANGED";
})(IssueEventType = exports.IssueEventType || (exports.IssueEventType = {}));
var EventParticipantType;
(function (EventParticipantType) {
    EventParticipantType["Actor"] = "ACTOR";
    EventParticipantType["Target"] = "TARGET";
})(EventParticipantType = exports.EventParticipantType || (exports.EventParticipantType = {}));
var OriginatingEntityType;
(function (OriginatingEntityType) {
    OriginatingEntityType["JiraIssue"] = "JIRA_ISSUE";
    OriginatingEntityType["GitHubCommit"] = "GITHUB_COMMIT";
    OriginatingEntityType["GitHubPullRequest"] = "GITHUB_PULL_REQUEST";
})(OriginatingEntityType = exports.OriginatingEntityType || (exports.OriginatingEntityType = {}));
// tslint:disable-next-line: variable-name
exports.EventType = { ...CommitEventType, ...PullRequestEventType, ...IssueEventType };
exports.PULL_REQUEST_REVIEWER_EVENTS = [
    PullRequestEventType.PullRequestCommitCommented,
    PullRequestEventType.PullRequestReviewedChangesRequested,
    PullRequestEventType.PullRequestReviewedApproved,
    PullRequestEventType.PullRequestReviewedCommented,
    PullRequestEventType.PullRequestLineCommented,
    PullRequestEventType.PullRequestReviewDismissed,
    PullRequestEventType.PullRequestComment
];
//# sourceMappingURL=events.js.map